import React from 'react';
import { useTranslation } from 'react-i18next';
import ListPageHeader from '@shared/ListPageHeader';
import WebhookDeliveryList from '@shared/webhook_deliveries/WebhookDeliveryList';
import { webhookDeliveryService } from '@services/operator/webhookDeliveryService';

export default function OperatorWebhookDeliveriesList() {
  const { t } = useTranslation();

  return (
    <div>
      <ListPageHeader items={['integration_logs', 'integration_logs.webhook_deliveries']} />
      <WebhookDeliveryList role="operator" service={webhookDeliveryService} />
    </div>
  );
}
